import SectionProductsList from './SectionProductsList';
export default SectionProductsList;
